/* HDD · Robot Aroma — page engine */
const CFG = {
  shop: '1xw5tj-jf.myshopify.com',          // Shopify domain used for the secure checkout
  preview: false,                             // shows the yellow preview bar + highlighted gaps
  shipDays: null,                            // e.g. '7–12 días laborables'  (null = pending)
  power: 's.powerV',                         // i18n key: robot power supply as stated by the supplier (USB-rechargeable battery)
  ship: { es: 6.99, free: 55, eu: 8.99 },    // must match Shopify › Settings › Shipping
  // seller details shown in the legal texts (LSSI). These win over the theme editor fields.
  business: { name: 'Lesslie Rafael Herrera Rivas (marca HDD)', nif: '77499612P', address: 'Camino del Estio 2, 11130 Chiclana de la Frontera (Cádiz), España', email: 'leader0market@gmail.com' },
};
function shipText(lang) { const d = (I18N[lang] || I18N.en)['p.ship'] || I18N.en['p.ship']; const loc = (LANGS.find(x => x[0] === lang) || [0, 0, 'es-ES'])[2];
  const m = v => new Intl.NumberFormat(loc, { style:'currency', currency:'EUR', minimumFractionDigits: v % 1 ? 2 : 0 }).format(v);
  return d.replace('{es}', m(CFG.ship.es)).replace('{free}', m(CFG.ship.free)).replace('{eu}', m(CFG.ship.eu)); }
const ROBOT = {
  B: { ocean:{id:'55014046466381',price:24.90}, gardenia:{id:'55014046335309',price:24.90}, cologne:{id:'55014046368077',price:24.90} },
  A: { ocean:{id:'55014046302541',price:24.90,img:'img/robot-a-ocean-hd.webp'}, gardenia:{id:'55014046400845',price:24.90,img:'img/robot-a-gardenia-hd.webp'}, cologne:{id:'55014046433613',price:24.90,img:'img/robot-a-cologne-hd.webp'} }
};
const GALLERY = { B:['3d','img/robot-b-cutout-hd.webp','img/robot-dims.webp','img/robot-b-dash.webp','img/robot-b-spray-hd.webp','img/life-macro-hd.webp','img/robot-modes-hd.webp'], A:['3d','img/robot-a-cologne-hd.webp','img/robot-a-gardenia-hd.webp','img/robot-a-ocean-hd.webp','img/robot-modes-hd.webp'] };
const FLAME = { black:{id:'55014044959053',price:9.99,img:'img/flame-black.webp'}, white:{id:'55014044991821',price:9.99,img:'img/flame-white.webp'} };
const OILS = [["55014045024589","Tea Tree",6.29],["55014045057357","Rosemary",7.39],["55014045090125","Patchouli",7.89],["55014045122893","Citronella",6.49],["55014045155661","Geranium",7.09],["55014045188429","Bergamot",6.39],["55014045221197","Rose",8.19],["55014045253965","Lemongrass",6.29],["55014045286733","Grapefruit",6.39],["55014045319501","Cinnamon",6.29],["55014045352269","Cedarwood",6.39],["55014045385037","Chamomile",6.99],["55014045417805","Myrrh",7.59],["55014045450573","Ginger",6.39],["55014045483341","Lemon Eucalyptus",6.59],["55014045516109","Vetiver",6.59],["55014045548877","Australian Tea Tree",6.39],["55014045581645","Spearmint",6.49],["55014045614413","Palo Santo",7.09],["55014045647181","Cardamom",6.39],["55014045679949","Honeysuckle",6.69],["55014045712717","Jasmine",7.69],["55014045745485","Lavender",6.59],["55014045778253","Sweet Orange",6.29],["55014045811021","Frankincense",6.99],["55014045843789","Lemon",7.29],["55014045876557","Ylang Ylang",6.59],["55014045909325","Vanilla",7.39],["55014045942093","Eucalyptus",7.19],["55014045974861","Sandalwood",7.79],["55014046007629","Peppermint",7.29]].map(([id,name,price])=>({id,name,price,slug:name.toLowerCase().replace(/ /g,'-')}));
const PHOTO = {es:'Foto',en:'Photo',fr:'Photo',de:'Foto',it:'Foto',pt:'Foto',nl:'Foto',pl:'Zdjęcie',sv:'Foto',da:'Foto',fi:'Kuva',nb:'Foto',cs:'Foto',ro:'Foto',hu:'Fotó',el:'Φωτογραφία',tr:'Fotoğraf',ar:'صورة',zh:'照片',ja:'写真'};

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
const smooth = (a, b, x) => { const t = clamp((x - a) / (b - a)); return t * t * (3 - 2 * t); };
const easeOut = x => 1 - Math.pow(1 - clamp(x), 3);
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const store = {
  get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
};
const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
const ASSETS = window.HDD_ASSETS || null;                 // optional explicit map: local path -> url
const FILES_BASE = window.HDD_FILES_BASE || null;         // set by the Shopify theme: Shopify Files folder (files are named hdd-<path with dashes>)
const A = p => (ASSETS && ASSETS[p]) || (FILES_BASE ? FILES_BASE + 'hdd-' + p.replace(/\//g, '-') : p);
const DPR = () => Math.min(devicePixelRatio || 1, 3);
const WSTEPS = [120, 180, 240, 360, 480, 640, 800, 1000, 1200, 1600, 2000, 2400];
// Shopify's CDN resizes images on request: ask for the width this screen actually needs (sharp on 3x phones, light on slow ones)
const AW = (p, cssW) => { const u = A(p); if (!FILES_BASE || !cssW) return u; const need = cssW * DPR(); const w = WSTEPS.find(x => x >= need) || 2400; return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };
const ON_SHOP = !!(ASSETS || FILES_BASE);
const SHOP_URL = ON_SHOP ? '' : 'https://' + CFG.shop;
// Live data printed by the Shopify theme: real prices from the store and the details filled in the theme editor
if (window.HDD_PRICES) {
  const P = window.HDD_PRICES;
  for (const m in ROBOT) for (const f in ROBOT[m]) if (P[ROBOT[m][f].id] != null) ROBOT[m][f].price = +P[ROBOT[m][f].id];
  for (const c in FLAME) if (P[FLAME[c].id] != null) FLAME[c].price = +P[FLAME[c].id];
  OILS.forEach(o => { if (P[o.id] != null) o.price = +P[o.id]; });
}
if (window.HDD_CFG) {
  const H = window.HDD_CFG, v = x => (x != null && String(x).trim()) || null;
  if (H.business) for (const k in CFG.business) CFG.business[k] = CFG.business[k] || v(H.business[k]);
  CFG.shipDays = v(H.shipDays) || CFG.shipDays;
  if (H.preview != null) CFG.preview = !!H.preview;
}

/* ---------------- i18n ---------------- */
let LANG = 'es', LOCALE = 'es-ES';
const FONT_LINKS = { ar:'Noto+Kufi+Arabic:wght@400;600;800', zh:'Noto+Sans+SC:wght@400;700;900', ja:'Noto+Sans+JP:wght@400;700;900' };
const t = k => (I18N[LANG] && I18N[LANG][k] != null ? I18N[LANG][k] : (I18N.en[k] != null ? I18N.en[k] : (I18N.es[k] != null ? I18N.es[k] : k)));
const money = v => new Intl.NumberFormat(LOCALE, { style:'currency', currency:'EUR' }).format(v);
const fill = v => v ? esc(v) : `<span class="fill">${esc(t('fill'))}</span>`;
function pickLang() {
  const saved = store.get('hdd.lang', null);
  if (saved && I18N[saved]) return saved;
  for (const l of (navigator.languages || [navigator.language || 'es'])) {
    let b = String(l).toLowerCase().split('-')[0];
    if (b === 'no' || b === 'nn') b = 'nb';
    if (I18N[b]) return b;
  }
  return 'en';
}
function ensureFont(l) {
  if (!FONT_LINKS[l] || document.getElementById('font-' + l)) return;
  const ln = document.createElement('link'); ln.id = 'font-' + l; ln.rel = 'stylesheet';
  ln.href = 'https://fonts.googleapis.com/css2?family=' + FONT_LINKS[l] + '&display=swap';
  document.head.appendChild(ln);
}
function setLang(l) {
  LANG = I18N[l] ? l : 'es';
  LOCALE = (LANGS.find(x => x[0] === LANG) || [0, 0, 'es-ES'])[2];
  store.set('hdd.lang', LANG);
  ensureFont(LANG);
  const root = document.documentElement;
  root.lang = LANG; root.dir = LANG === 'ar' ? 'rtl' : 'ltr';
  $$('[data-i18n]').forEach(el => { el.textContent = t(el.dataset.i18n); });
  $$('[data-i18n-aria]').forEach(el => el.setAttribute('aria-label', t(el.dataset.i18nAria)));
  $$('[data-i18n="x.photo"]').forEach(el => { el.textContent = PHOTO[LANG] || 'Photo'; });
  $('#lang').value = LANG;
  renderProduct(); renderExtras(); renderCart();
  $('#powerV').innerHTML = CFG.power ? esc(t(CFG.power)) : fill(null);
  $('#shipLine').textContent = shipText(LANG); $('#shipFaq').textContent = shipText(LANG);
  renderReviews();
  $('#shipDays').innerHTML = fill(CFG.shipDays);
  drawModes();
}

/* ---------------- Film (scroll-scrubbed sequence) ---------------- */
const FILM_END = 0.84;
const film = { el:$('#film'), cv:$('#filmCv'), bg:$('#filmBg'), N:0, urls:[], cache:new Map(), want:0, drawn:-1, p:0, ps:0, ready:false, landscape:false, dpr:1 };
const fctx = film.cv.getContext('2d');
const bctx = film.bg.getContext('2d');
const chapters = $$('.ch').map(el => { const [a, b] = el.dataset.ch.split(',').map(Number); return { el, a, b }; });

const ASSET_MODE = 'packed';   // 'packed' = chunked film + .glb (own hosting) · 'loose' = single frames + base64 model (preview host)
async function loadFilm() {
  try {
    const dispH = innerWidth > innerHeight ? innerHeight : Math.max(innerHeight, innerWidth * 1.778);
    const hd = ASSET_MODE === 'loose' || dispH * (devicePixelRatio || 1) > 1300;
    let meta = null;
    if (ASSET_MODE === 'loose') meta = await (await fetch('media/film.json')).json();
    else for (const tier of (hd ? ['hd', 'sd'] : ['sd', 'hd'])) {
      try { const r = await fetch(A('media/film2-' + tier + '.json')); if (r.ok) { meta = await r.json(); break; } } catch (e) {}
    }
    if (!meta) throw new Error('film meta');
    film.N = meta.count; film.urls = new Array(meta.count).fill(null); film.cacheMax = (meta.w > 800 || ASSET_MODE === 'loose') ? 14 : 36;
    let n = 0; const lab = $('#filmLoad');
    const done = () => { lab.textContent = Math.round(n / meta.count * 100) + '%'; };
    if (ASSET_MODE === 'loose') {
      const order = [...Array(meta.count).keys()].sort((a, b) => ((a % 6 === 0) ? 0 : 1) - ((b % 6 === 0) ? 0 : 1) || a - b);
      let k = 0, first = true;
      const worker = async () => {
        while (k < order.length) {
          const i = order[k++]; const src = 'media/seq/f' + String(i + 1).padStart(3, '0') + '.webp';
          await new Promise(res => { const im = new Image(); im.onload = im.onerror = res; im.src = src; });
          film.urls[i] = src; n++; done();
          if (first && n >= Math.ceil(meta.count / 6)) { first = false; film.ready = true; film.drawn = -1; tick(true); }
        }
      };
      await Promise.all([worker(), worker(), worker(), worker(), worker(), worker()]);
      if (first) { film.ready = true; tick(true); }
    } else {
      for (let ci = 0; ci < meta.chunks.length; ci++) {
        const ch = meta.chunks[ci];
        const res = await fetch(A(ch.file)); if (!res.ok) throw new Error('film chunk ' + res.status);
        const buf = await res.arrayBuffer();
        // every chunk starts with a non-image header: if it is missing, a proxy/CDN has rewritten the file
        if (meta.header && new TextDecoder().decode(new Uint8Array(buf, 0, 8)) !== 'HDDFILM2') throw new Error('film chunk rewritten');
        for (const [i, off, len] of ch.frames) { film.urls[i] = URL.createObjectURL(new Blob([buf.slice(off, off + len)], { type:'image/webp' })); n++; }
        done();
        if (ci === 0) { film.ready = true; film.drawn = -1; tick(true); }
      }
    }
    lab.style.opacity = 0;
  } catch (e) { console.warn('film', e); $('#filmLoad').hidden = true; }
}
function nearestUrl(i) {
  if (film.urls[i]) return i;
  for (let d = 1; d < film.N; d++) { if (i - d >= 0 && film.urls[i - d]) return i - d; if (i + d < film.N && film.urls[i + d]) return i + d; }
  return -1;
}
function getFrame(i) {
  const c = film.cache.get(i);
  if (c) { film.cache.delete(i); film.cache.set(i, c); return c; }
  if (!film.urls[i]) return null;
  const im = new Image(); im.decoding = 'async'; im.src = film.urls[i];
  im.decode().then(() => {
    film.cache.set(i, im);
    while (film.cache.size > (film.cacheMax || 36)) film.cache.delete(film.cache.keys().next().value);
    if (Math.abs(i - film.want) <= 1) { film.drawn = -1; tick(true); }
  }).catch(() => {});
  return null;
}
function closestCached(i) {
  let best = null, bd = 1e9;
  for (const [k, v] of film.cache) { const d = Math.abs(k - i); if (d < bd) { bd = d; best = v; } }
  return best;
}
function sizeFilm() {
  const st = film.cv.parentElement; const w = st.clientWidth, h = st.clientHeight;
  // full device resolution (up to 3x phones), within a pixel budget so huge screens stay smooth
  film.dpr = Math.max(1, Math.min(devicePixelRatio || 1, 3, Math.sqrt(9e6 / Math.max(1, w * h))));
  film.cv.width = Math.round(w * film.dpr); film.cv.height = Math.round(h * film.dpr);
  film.landscape = w / h > 0.82;
  film.el.classList.toggle('is-landscape', film.landscape);
  film.drawn = -1;
}
function drawFrame(img) {
  const W = film.cv.width, H = film.cv.height, iw = img.naturalWidth, ih = img.naturalHeight;
  const s = film.landscape ? Math.min(W / iw, H / ih) : Math.max(W / iw, H / ih);
  const dw = iw * s, dh = ih * s;
  fctx.imageSmoothingEnabled = true; fctx.imageSmoothingQuality = 'high';
  fctx.clearRect(0, 0, W, H);
  fctx.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
  if (film.landscape) bctx.drawImage(img, 0, 0, 72, 128);
}
function renderFilm() {
  if (!film.ready || !film.N) return;
  const pf = clamp(film.ps / FILM_END);
  const i = Math.round(pf * (film.N - 1));
  film.want = i;
  const j = nearestUrl(i); if (j < 0) return;
  let img = getFrame(j) || closestCached(j);
  for (let k = 1; k <= 3; k++) { if (i + k < film.N) getFrame(nearestUrl(i + k)); }
  if (img && film.drawn !== j) { drawFrame(img); if (film.cache.get(j) === img) film.drawn = j; }
  if (!film.el.classList.contains('is-ready') && img) film.el.classList.add('is-ready');
}
function filmProgress() {
  const r = film.el.getBoundingClientRect();
  const total = film.el.offsetHeight - innerHeight;
  return total > 0 ? clamp(-r.top / total) : 0;
}
let heroT = 0, heroVisible = false, rafOn = false;
function updateOverlay() {
  const ps = film.ps, pf = clamp(ps / FILM_END);
  for (const c of chapters) {
    const o = smooth(c.a, c.a + 0.025, pf) * (1 - smooth(c.b - 0.025, c.b, pf));
    c.el.style.opacity = o.toFixed(3);
    if (!film.landscape) c.el.style.transform = `translateY(${((1 - o) * 14).toFixed(1)}px)`;
    else c.el.style.transform = `translateY(calc(-50% + ${((1 - o) * 14).toFixed(1)}px))`;
  }
  $('#filmVeil').style.opacity = smooth(0.80, 0.875, ps).toFixed(3);
  const fo = smooth(0.835, 0.885, ps);
  $('#fin').style.opacity = fo.toFixed(3);
  $('#fin').style.pointerEvents = fo > 0.6 ? 'auto' : 'none';
  const sk = $('#filmSkip'); sk.style.opacity = (1 - fo).toFixed(3); sk.style.pointerEvents = fo > 0.5 ? 'none' : 'auto';
  heroT = clamp((ps - FILM_END) / (1 - FILM_END));
  $('#filmHint').style.opacity = (1 - smooth(0.004, 0.03, ps)).toFixed(3);
  $('#filmBar').style.width = (ps * 100).toFixed(2) + '%';
  const r = film.el.getBoundingClientRect();
  heroVisible = r.bottom > innerHeight * 0.35 && fo > 0.01;
  $('.fin__foot').style.opacity = smooth(innerHeight * 0.6, innerHeight * 0.97, r.bottom).toFixed(3);
}
function headerTone() {
  const hdr = $('#hdr'); const r = film.el.getBoundingClientRect();
  if (r.bottom > 64) {
    const pf = film.ps / FILM_END;
    const dark = film.ps > 0.82 || (!film.landscape && pf > 0.575);
    hdr.dataset.tone = dark ? 'dark' : 'light'; hdr.classList.remove('is-solid'); return;
  }
  hdr.classList.add('is-solid');
  for (const s of $$('[data-tone]:not(#hdr)')) {
    const b = s.getBoundingClientRect();
    if (b.top <= 40 && b.bottom > 40) { hdr.dataset.tone = s.dataset.tone; return; }
  }
}
function tick(force) {
  if (rafOn && !force) return;
  rafOn = true;
  requestAnimationFrame(loop);
}
function loop() {
  film.p = filmProgress();
  const k = REDUCED ? 1 : 0.18;
  film.ps += (film.p - film.ps) * k;
  if (Math.abs(film.p - film.ps) < 0.0004) film.ps = film.p;
  renderFilm(); updateOverlay(); headerTone(); RobotStage.route();
  if (film.ps !== film.p) requestAnimationFrame(loop); else rafOn = false;
}
addEventListener('scroll', () => tick(), { passive:true });
addEventListener('resize', () => { sizeFilm(); drawModes(); tick(true); });

/* ---------------- 3D ---------------- */
let THREE = null, GLTFLoader = null, RoomEnvironment = null, threeFailed = false;
async function loadThree() {
  if (THREE || threeFailed) return !!THREE;
  try {
    THREE = await import('three');
    ({ GLTFLoader } = await import('three/addons/loaders/GLTFLoader.js'));
    ({ RoomEnvironment } = await import('three/addons/environments/RoomEnvironment.js'));
    return true;
  } catch (e) { console.warn('three', e); threeFailed = true; return false; }
}
function shadowTex() {
  const c = document.createElement('canvas'); c.width = c.height = 128; const g = c.getContext('2d');
  const gr = g.createRadialGradient(64, 64, 4, 64, 64, 62); gr.addColorStop(0, 'rgba(0,0,0,.42)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
  g.fillStyle = gr; g.fillRect(0, 0, 128, 128); return new THREE.CanvasTexture(c);
}
class Viewer {
  constructor(host, o = {}) {
    this.o = Object.assign({ fov:28, exposure:1.15, interactive:true, auto:0.0032, fit:0.72, yaw:0, lift:0 }, o);
    this.host = host;
    this.canvas = document.createElement('canvas');
    this.r = new THREE.WebGLRenderer({ canvas:this.canvas, antialias:true, alpha:true, powerPreference:'high-performance' });
    this.r.setPixelRatio(Math.min(devicePixelRatio || 1, 3));
    this.r.toneMapping = THREE.ACESFilmicToneMapping; this.r.toneMappingExposure = this.o.exposure;
    this.r.outputColorSpace = THREE.SRGBColorSpace;
    this.scene = new THREE.Scene();
    const pm = new THREE.PMREMGenerator(this.r); this.scene.environment = pm.fromScene(new RoomEnvironment(), 0.04).texture; pm.dispose();
    this.key = new THREE.DirectionalLight('#fff1d6', 2.2); this.key.position.set(2, 3, 3);
    this.rim = new THREE.DirectionalLight('#d6ae55', 3.0); this.rim.position.set(-3, 1.5, -2);
    this.fill = new THREE.DirectionalLight('#bfe6ff', 0.8); this.fill.position.set(-2, 0, 3);
    this.scene.add(this.key, this.rim, this.fill);
    this.cam = new THREE.PerspectiveCamera(this.o.fov, 1, 0.05, 50);
    this.pivot = new THREE.Group(); this.scene.add(this.pivot);
    this.shadow = new THREE.Mesh(new THREE.PlaneGeometry(1.6, 1.6), new THREE.MeshBasicMaterial({ map:shadowTex(), transparent:true, depthWrite:false }));
    this.shadow.rotation.x = -Math.PI / 2; this.scene.add(this.shadow);
    this.yaw = this.o.yaw; this.pitch = 0; this.vel = 0; this.drag = null; this.idle = 0; this.on = false; this.onFrame = null; this.h = 1;
    if (this.o.interactive) this.bindPointer();
    this.ro = new ResizeObserver(() => this.resize());
    this.io = new IntersectionObserver(es => { this.visible = es[0].isIntersecting; if (this.visible) this.start(); }, { rootMargin:'120px' });
    this.mount(host);
  }
  mount(host) {
    if (this.host && this.host !== host) { this.ro.unobserve(this.host); this.io.unobserve(this.host); }
    this.host = host; host.appendChild(this.canvas);
    this.ro.observe(host); this.io.observe(host); this.resize(); this.start();
  }
  setObject(obj, height = 1) {
    while (this.pivot.children.length) this.pivot.remove(this.pivot.children[0]);
    this.pivot.add(obj); this.h = height; this.shadow.position.y = -height / 2 + 0.002; this.shadow.scale.setScalar(height * 0.9); this.frameCam(); this.start();
  }
  frameCam() {
    const w = this.host.clientWidth || 1, h = this.host.clientHeight || 1;
    this.cam.aspect = w / h;
    const vfit = this.h / this.o.fit; let d = vfit / (2 * Math.tan(THREE.MathUtils.degToRad(this.o.fov / 2)));
    const hfov = 2 * Math.atan(Math.tan(THREE.MathUtils.degToRad(this.o.fov / 2)) * this.cam.aspect);
    const wfit = (this.o.width || this.h * 0.7) / 0.8; d = Math.max(d, wfit / (2 * Math.tan(hfov / 2)));
    this.cam.position.set(0, this.h * 0.08 + this.o.lift, d); this.cam.lookAt(0, this.o.lift, 0); this.cam.updateProjectionMatrix();
  }
  resize() {
    const w = this.host.clientWidth, h = this.host.clientHeight; if (!w || !h) return;
    // render at the screen's real density (3x on most phones) but cap the pixel count for weaker GPUs
    const pr = Math.max(1, Math.min(devicePixelRatio || 1, 3, Math.sqrt(2.6e6 / (w * h))));
    if (Math.abs(this.r.getPixelRatio() - pr) > 0.01) this.r.setPixelRatio(pr);
    this.r.setSize(w, h, false); this.frameCam(); this.render();
  }
  bindPointer() {
    const c = this.canvas;
    c.addEventListener('pointerdown', e => { this.drag = { x:e.clientX, y:e.clientY, yaw:this.yaw, pitch:this.pitch, t:performance.now() }; this.vel = 0; c.setPointerCapture(e.pointerId); this.start(); });
    c.addEventListener('pointermove', e => {
      if (!this.drag) return;
      const dx = e.clientX - this.drag.x, dy = e.clientY - this.drag.y;
      const ny = this.drag.yaw + dx * 0.012; this.vel = ny - this.yaw; this.yaw = ny;
      this.pitch = clamp(this.drag.pitch + dy * 0.004, -0.35, 0.35); this.idle = 0; hideDragHint();
    });
    const end = () => { this.drag = null; this.idle = 0; };
    c.addEventListener('pointerup', end); c.addEventListener('pointercancel', end);
  }
  start() { if (this.on) return; this.on = true; this.last = performance.now(); requestAnimationFrame(t => this.frame(t)); }
  frame(now) {
    if (!this.visible || document.hidden) { this.on = false; return; }
    const dt = Math.min(0.05, (now - this.last) / 1000); this.last = now;
    if (!this.drag && this.o.interactive) {
      this.yaw += this.vel; this.vel *= 0.92; this.idle += dt;
      if (this.idle > 2.2 && !REDUCED) this.yaw += this.o.auto * 60 * dt;
      this.pitch *= 0.96;
    } else if (!this.o.interactive && !REDUCED) this.yaw += this.o.auto * 60 * dt;
    this.pivot.rotation.set(this.pitch, this.yaw, 0);
    if (this.onFrame) this.onFrame(now / 1000, dt);
    this.render();
    requestAnimationFrame(t => this.frame(t));
  }
  render() { this.r.render(this.scene, this.cam); }
}

/* --- Robots (GLB from the supplier photos) shared by hero, product and cart --- */
const FACE = -0.79;
const MODELS = { B:{ file:'3d/robot', cut:0.272, r:0.288 }, A:{ file:'3d/robot-a', cut:0.292, r:0.3, w:0.8, face:-1.36 } };
MODELS.B.w = 0.62; MODELS.B.face = FACE;
const A_TINT = { ocean:'#86bfe8', gardenia:'#93cf9c', cologne:null };
function tintable(mat) {
  mat.userData.uTint = { value:new THREE.Color('#000000') }; mat.userData.uOn = { value:0 };
  mat.onBeforeCompile = sh => {
    sh.uniforms.uTint = mat.userData.uTint; sh.uniforms.uOn = mat.userData.uOn;
    sh.fragmentShader = 'uniform vec3 uTint; uniform float uOn;\n' + sh.fragmentShader.replace('#include <map_fragment>', `#include <map_fragment>
      { float lum = dot(diffuseColor.rgb, vec3(0.2126, 0.7152, 0.0722));
        float sat = max(max(diffuseColor.r, diffuseColor.g), diffuseColor.b) - min(min(diffuseColor.r, diffuseColor.g), diffuseColor.b);
        float body = smoothstep(${MODELS.A.tLo.toFixed(4)}, ${MODELS.A.tHi.toFixed(4)}, lum) * (1.0 - smoothstep(0.05, 0.12, sat)) * (1.0 - smoothstep(0.25, 0.45, lum));
        diffuseColor.rgb = mix(diffuseColor.rgb, uTint * (0.22 + lum * 4.0), body * uOn); }`);
  };
  mat.customProgramCacheKey = () => 'tintA';
}
MODELS.A.tLo = 0.020; MODELS.A.tHi = 0.040;
const RobotStage = {
  viewer:null, objs:{}, pend:{}, cur:null, obj:null, spin:null, mode:null, key:null, failed:false,
  load(key) {
    if (this.pend[key]) return this.pend[key];
    return this.pend[key] = (async () => {
      const M = MODELS[key]; let gltf;
      if (ASSET_MODE === 'loose') {
        const b64 = (await (await fetch(M.file + '.glb.txt')).text()).trim();
        const bin = Uint8Array.from(atob(b64), c => c.charCodeAt(0)).buffer;
        gltf = await new GLTFLoader().parseAsync(bin, '');
      } else gltf = await new GLTFLoader().loadAsync(A(M.file + '.glb'));
      const m = gltf.scene;
      m.traverse(o => { if (o.isMesh) { const mt = o.material; mt.metalness = 0.45; mt.envMapIntensity = 1.4; mt.emissiveIntensity = 2.2; if (key === 'A') { mt.metalness = 1; mt.roughness = 1; tintable(mt); } } });
      const box = new THREE.Box3().setFromObject(m); const size = box.getSize(new THREE.Vector3()); const c = box.getCenter(new THREE.Vector3());
      const sc = 1 / size.y; m.scale.setScalar(sc); m.position.set(-c.x * sc, -c.y * sc, -c.z * sc);
      const spin = new THREE.Group(); spin.add(m);
      const ctr = cutBelow(spin, -0.5 + M.cut);
      const base = makeGlassBase(M.r, M.cut - 0.003); base.position.set(ctr.x, -0.5, ctr.z); spin.add(base);
      spin.rotation.y = M.face; const holder = new THREE.Group(); holder.add(spin);
      const mats = []; m.traverse(o => { if (o.isMesh) mats.push(o.material); });
      return (this.objs[key] = { holder, spin, mats });
    })();
  },
  async init() {
    if (!(await loadThree())) return this.fail();
    try {
      await this.load('B');
      this.viewer = new Viewer($('#prod3d'), { fit:0.74, width:0.62 });
      this.viewer.onFrame = (time) => this.onFrame(time);
      this.show('B'); this.mode = 'product'; this.route();
    } catch (e) { console.warn('robot', e); this.fail(); }
  },
  show(key) {
    const o = this.objs[key]; if (!o) return false;
    if (key === 'A') { const col = A_TINT[this.mode === 'cart' ? this.cartFrag : productFrag];
      o.mats.forEach(mt => { if (mt.userData.uOn) { mt.userData.uOn.value = col ? 1 : 0; if (col) mt.userData.uTint.value.set(col); } }); }
    this.viewer.o.width = MODELS[key].w;
    if (this.cur === o) { this.viewer.frameCam(); return true; }
    this.cur = o; this.obj = o.holder; this.spin = o.spin; this.key = key; this.face = MODELS[key].face; this.viewer.setObject(o.holder, 1); return true;
  },
  fail() { this.failed = true; $('#heroFallback').hidden = false; showStagePhoto('img/robot-b-cutout-hd.webp', true); },
  onFrame(time) {
    const v = this.viewer; if (!this.obj) return;
    if (this.mode === 'hero') {
      const k = easeOut(heroT / 0.62);
      this.obj.position.y = -1.5 * (1 - k);
      this.spin.rotation.y = this.face - (1 - easeOut(heroT / 0.9)) * Math.PI * 2.4;
      v.pivot.rotation.set(0, 0, 0); v.yaw = 0;
      v.rim.position.set(Math.cos(time * 0.6 + heroT * 4) * -3.2, 1.6, Math.sin(time * 0.6 + heroT * 4) * -3.2);
      v.shadow.material.opacity = k;
    } else {
      this.obj.position.y = 0; this.spin.rotation.y = this.face; v.shadow.material.opacity = 1;
    }
  },
  route() {
    if (!this.viewer) return;
    const cartOpen = $('#drawer').classList.contains('is-on') && !$('#cartHero').hidden;
    const want = cartOpen ? 'cart' : heroVisible ? 'hero' : 'product';
    const line = cart.find(l => l.kind === 'robot');
    this.cartFrag = line ? line.variant.frag : 'ocean';
    const key = want === 'hero' ? 'B' : want === 'cart' ? (line ? line.variant.model : 'B') : productModel;
    const sig = want + key + (key === 'A' ? (want === 'cart' ? this.cartFrag : productFrag) : '');
    if (sig === this.sig) return;
    if (!this.objs[key]) { if (!this.pend[key]) this.load(key).then(() => { this.sig = null; applyGallery(); this.route(); }).catch(e => console.warn('robot ' + key, e)); 
      if (this.mode !== 'none') { this.viewer.canvas.remove(); this.mode = 'none'; } this.sig = null; return; }
    if (want === 'product' && GALLERY[productModel][galleryIdx] !== '3d') { this.sig = sig; if (this.mode !== 'none') { this.viewer.canvas.remove(); this.mode = 'none'; } return; }
    this.sig = sig; const v = this.viewer; this.mode = want; this.show(key);
    if (want === 'hero') { v.o.interactive = false; v.o.fit = film.landscape ? 0.58 : 0.4; v.o.lift = -0.05; v.mount($('#hero3d')); }
    if (want === 'product') { v.o.interactive = true; v.o.fit = 0.74; v.o.lift = 0; v.yaw = 0; v.mount($('#prod3d')); }
    if (want === 'cart') { v.o.interactive = false; v.o.fit = 0.9; v.o.lift = 0; v.mount($('#cart3d')); }
    $('#hero3d').style.opacity = want === 'hero' ? 1 : 0;
  }
};

/* --- Flame diffuser (procedural, modelled on the supplier photos) --- */
const FLAME_COLORS = ['#ff2d2d','#ff8a1f','#2bd94a','#19d0e6','#2a5bff','#ff3ad6','#8a3aff'];
function makeFlame(colorName) {
  const g = new THREE.Group();
  const w = 2.0, d = 1.0, h = 0.92, r = d / 2;
  const s = new THREE.Shape();
  s.moveTo(-w / 2 + r, -r); s.lineTo(w / 2 - r, -r); s.absarc(w / 2 - r, 0, r, -Math.PI / 2, Math.PI / 2, false);
  s.lineTo(-w / 2 + r, r); s.absarc(-w / 2 + r, 0, r, Math.PI / 2, Math.PI * 1.5, false);
  const geo = new THREE.ExtrudeGeometry(s, { depth:h, bevelEnabled:true, bevelThickness:0.07, bevelSize:0.07, bevelSegments:8, curveSegments:64 });
  geo.rotateX(-Math.PI / 2);
  const dark = colorName === 'black';
  const body = new THREE.Mesh(geo, new THREE.MeshPhysicalMaterial({ color: dark ? '#111113' : '#efefec', roughness: dark ? 0.32 : 0.42, clearcoat:0.6, clearcoatRoughness:0.25, metalness:0 }));
  g.add(body);
  const topR = new THREE.Mesh(new THREE.CylinderGeometry(0.2, 0.2, 0.02, 48), new THREE.MeshStandardMaterial({ color:'#060606', roughness:0.8 }));
  topR.scale.set(1.6, 1, 0.9); topR.position.y = h + 0.07; g.add(topR);
  // front icon: three wavy lines + two buttons
  const c = document.createElement('canvas'); c.width = 256; c.height = 256; const x = c.getContext('2d');
  x.lineCap = 'round'; x.lineWidth = 11; x.strokeStyle = '#fff';
  for (let k = -1; k <= 1; k++) { x.beginPath(); for (let yy = 40; yy <= 150; yy += 4) { const xx = 128 + k * 34 + Math.sin((yy - 40) / 110 * Math.PI * 2) * 9; yy === 40 ? x.moveTo(xx, yy) : x.lineTo(xx, yy); } x.stroke(); }
  x.fillStyle = dark ? '#5a5a5a' : '#c9c9c4'; x.beginPath(); x.roundRect(86, 196, 34, 14, 7); x.fill(); x.beginPath(); x.roundRect(136, 196, 34, 14, 7); x.fill();
  const iconTex = new THREE.CanvasTexture(c); iconTex.colorSpace = THREE.SRGBColorSpace;
  const icon = new THREE.Mesh(new THREE.PlaneGeometry(0.42, 0.42), new THREE.MeshStandardMaterial({ map:iconTex, transparent:true, emissive:'#ffffff', emissiveMap:iconTex, emissiveIntensity:1.2, color: dark ? '#ffffff' : '#bdbdb8', roughness:0.6 }));
  icon.position.set(0, h * 0.5, r + 0.071); g.add(icon);
  // flame: crossed planes with an animated noise shader
  const mat = new THREE.ShaderMaterial({
    uniforms:{ uTime:{ value:0 }, uColor:{ value:new THREE.Color(FLAME_COLORS[2]) } },
    vertexShader:'varying vec2 vUv; void main(){ vUv=uv; gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0); }',
    fragmentShader:`uniform float uTime; uniform vec3 uColor; varying vec2 vUv;
      float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
      float n(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),u.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),u.x),u.y);}
      float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p*=2.03;a*=.5;}return v;}
      void main(){ vec2 uv=vUv; float y=uv.y; vec2 q=vec2(uv.x*2.6,y*2.2-uTime*0.85);
        float f=fbm(q+fbm(q*1.4+uTime*0.15)); float wdt=mix(0.34,0.05,pow(y,0.75));
        float dx=abs(uv.x-0.5+(f-0.5)*0.4*y); float shape=smoothstep(wdt,wdt*0.2,dx);
        float a=shape*smoothstep(1.0,0.12,y+(f-0.5)*0.55)*smoothstep(0.0,0.1,y); a=clamp(a*(0.5+f),0.,1.);
        vec3 col=mix(uColor*1.7,vec3(1.0),pow(a,3.0)*0.4); gl_FragColor=vec4(col*a,a*0.9); }`,
    transparent:true, depthWrite:false, blending:THREE.AdditiveBlending, side:THREE.DoubleSide
  });
  const fl = new THREE.Group();
  for (let k = 0; k < 3; k++) { const p = new THREE.Mesh(new THREE.PlaneGeometry(1.25, 1.5), mat); p.rotation.y = k * Math.PI / 3; fl.add(p); }
  fl.position.y = h + 0.07 + 0.72; g.add(fl);
  const glow = new THREE.PointLight(FLAME_COLORS[2], 2.2, 3); glow.position.y = h + 0.35; g.add(glow);
  g.position.y = -(h + 0.07 + 1.4) / 2 + 0.05;
  g.userData = { mat, glow, iconMat: icon.material, dark };
  return g;
}
function animateFlame(obj, time) {
  const u = obj.userData; if (!u.mat) return;
  u.mat.uniforms.uTime.value = time;
  const p = (time / 2.6) % FLAME_COLORS.length; const i = Math.floor(p), f = smooth(0.75, 1, p - i);
  const col = new THREE.Color(FLAME_COLORS[i]).lerp(new THREE.Color(FLAME_COLORS[(i + 1) % FLAME_COLORS.length]), f);
  u.mat.uniforms.uColor.value.copy(col); u.glow.color.copy(col);
  if (u.dark) u.iconMat.emissive.copy(col);
}

/* --- Essential-oil bottle (procedural, real label from the supplier photo) --- */
const texLoader = () => new THREE.TextureLoader();
function makeOil(slug) {
  const g = new THREE.Group();
  const R = 0.3, H = 1.74;
  const prof = [[0,0],[R-0.03,0],[R,0.03],[R,H-0.08],[R-0.05,H],[0.13,H+0.06],[0.12,H+0.12],[0,H+0.12]].map(p => new THREE.Vector2(p[0], p[1]));
  const glass = new THREE.Mesh(new THREE.LatheGeometry(prof, 72), new THREE.MeshPhysicalMaterial({ color:'#7b3a0b', roughness:0.08, metalness:0, clearcoat:1, clearcoatRoughness:0.04, envMapIntensity:1.6 }));
  g.add(glass);
  const L = 2.6, LH = 1.31;
  const labelMat = new THREE.MeshStandardMaterial({ color:'#ffffff', roughness:0.55 });
  const label = new THREE.Mesh(new THREE.CylinderGeometry(R + 0.004, R + 0.004, LH, 72, 1, true, -L / 2, L), labelMat);
  label.position.y = 0.16 + LH / 2; g.add(label);
  const cap = new THREE.Mesh(new THREE.CylinderGeometry(0.205, 0.205, 0.3, 48), new THREE.MeshStandardMaterial({ color:'#0b0b0b', roughness:0.35 }));
  cap.position.y = H + 0.1 + 0.15; g.add(cap);
  // dropper beside the bottle, as shipped
  const dr = new THREE.Group();
  const tube = new THREE.Mesh(new THREE.CylinderGeometry(0.028, 0.02, 1.25, 20), new THREE.MeshPhysicalMaterial({ color:'#e8eef0', roughness:0.05, transmission:0.8, thickness:0.05, transparent:true, opacity:0.55 }));
  tube.position.y = 0.62; dr.add(tube);
  const collar = new THREE.Mesh(new THREE.CylinderGeometry(0.2, 0.2, 0.16, 40), new THREE.MeshStandardMaterial({ color:'#0b0b0b', roughness:0.4 })); collar.position.y = 1.32; dr.add(collar);
  const bulb = new THREE.Mesh(new THREE.CapsuleGeometry(0.1, 0.22, 8, 24), new THREE.MeshStandardMaterial({ color:'#0a0a0a', roughness:0.25 })); bulb.position.y = 1.58; dr.add(bulb);
  dr.position.set(-0.62, 0.18, -0.05); g.add(dr);
  g.position.y = -(H + 0.4) / 2;
  g.userData = { labelMat };
  setOilLabel(g, slug);
  return g;
}
function setOilLabel(g, slug) {
  texLoader().load(A('img/labels/' + slug + '.webp'), tx => { tx.colorSpace = THREE.SRGBColorSpace; tx.anisotropy = 4; const m = g.userData.labelMat; if (m.map) m.map.dispose(); m.map = tx; m.needsUpdate = true; });
}

/* ---------------- Product UI ---------------- */
let productModel = 'B', productFrag = 'ocean', qty = 1, galleryIdx = 0;
function variant() { return ROBOT[productModel][productFrag]; }
function showStagePhoto(src, contain) {
  const st = $('#stage'); const im = $('#stageImg'); im.src = AW(src, Math.max(st.clientWidth, st.clientHeight) || 600); im.hidden = false; im.classList.toggle('is-contain', !!contain);
}
function hideStagePhoto() { $('#stageImg').hidden = true; }
let hintHidden = false;
function hideDragHint() { if (hintHidden) return; hintHidden = true; $('#dragHint').style.opacity = 0; }
function renderThumbs() {
  const box = $('#thumbs'); const list = GALLERY[productModel];
  box.innerHTML = list.map((s, i) => s === '3d' ? `<button class="thumb thumb--3d" type="button" data-i="${i}" aria-pressed="${i === galleryIdx}">3D</button>`
    : s === 'A' ? `<button class="thumb" type="button" data-i="${i}" aria-pressed="${i === galleryIdx}"><img src="${AW(ROBOT.A[productFrag].img, 72)}" alt=""></button>`
    : `<button class="thumb" type="button" data-i="${i}" aria-pressed="${i === galleryIdx}"><img src="${AW(s, 72)}" alt="" loading="lazy"></button>`).join('');
}
function applyGallery() {
  const list = GALLERY[productModel]; const s = list[galleryIdx];
  const ready = !!RobotStage.objs[productModel] && !RobotStage.failed;
  $('#stageNote').hidden = true;
  if (s === '3d' && ready) { hideStagePhoto(); $('#dragHint').hidden = false; }
  else {
    $('#dragHint').hidden = true;
    const src = s === '3d' ? (productModel === 'A' ? ROBOT.A[productFrag].img : 'img/robot-b-cutout-hd.webp') : s;
    showStagePhoto(src, src.includes('cutout') || src.includes('dims') || src.includes('robot-a-'));
  }
  $$('#thumbs .thumb').forEach((b, i) => b.setAttribute('aria-pressed', String(i === galleryIdx)));
  RobotStage.sig = null; RobotStage.route();
}
function renderProduct() {
  $('#price').textContent = money(variant().price * 1);
  $('#modelOut').textContent = '· ' + t(productModel === 'B' ? 'p.modelB' : 'p.modelA');
  $('#fragOut').textContent = '· ' + productFrag[0].toUpperCase() + productFrag.slice(1);
  $$('#modelChips .chip').forEach(b => b.setAttribute('aria-checked', String(b.dataset.model === productModel)));
  $$('#fragChips .chip').forEach(b => b.setAttribute('aria-checked', String(b.dataset.frag === productFrag)));
  $('#qOut').textContent = qty;
  $('#buyNow').href = `${SHOP_URL}/cart/${variant().id}:${qty}`;
  renderThumbs(); applyGallery();
}
$('#modelChips').addEventListener('click', e => { const b = e.target.closest('[data-model]'); if (!b) return; productModel = b.dataset.model; galleryIdx = 0; renderProduct(); });
$('#fragChips').addEventListener('click', e => { const b = e.target.closest('[data-frag]'); if (!b) return; productFrag = b.dataset.frag; if (productModel === 'A' && GALLERY.A[galleryIdx] !== '3d') galleryIdx = 1 + ['cologne','gardenia','ocean'].indexOf(productFrag); renderProduct(); });
$('#thumbs').addEventListener('click', e => { const b = e.target.closest('[data-i]'); if (!b) return; galleryIdx = +b.dataset.i; applyGallery(); });
$('#qMinus').addEventListener('click', () => { qty = Math.max(1, qty - 1); renderProduct(); });
$('#qPlus').addEventListener('click', () => { qty = Math.min(9, qty + 1); renderProduct(); });
$('#addRobot').addEventListener('click', () => {
  const v = variant();
  addToCart({ id:v.id, qty, kind:'robot', title:'Robot Aroma', variant:{ model:productModel, frag:productFrag }, price:v.price, img: productModel === 'A' ? ROBOT.A[productFrag].img : 'img/robot-b-cutout-hd.webp' });
});

/* ---------------- Extras ---------------- */
let flameColor = 'black', oilIdx = OILS.findIndex(o => o.slug === 'lavender');
const Extras = { flame:null, oil:null };
function oilName(o) { return LANG === 'es' ? (OIL_ES[o.name] || o.name) : o.name; }
function renderExtras() {
  $('#flamePrice').textContent = money(FLAME[flameColor].price);
  $$('#flameChips .chip').forEach(b => b.setAttribute('aria-checked', String(b.dataset.flame === flameColor)));
  const sel = $('#oilSel');
  sel.innerHTML = OILS.map((o, i) => `<option value="${i}">${esc(oilName(o))} · ${money(o.price)}</option>`).join('');
  sel.value = String(oilIdx);
  $('#oilPrice').textContent = money(OILS[oilIdx].price);
  renderExThumbs('flame'); renderExThumbs('oil');
}
$('#flameChips').addEventListener('click', e => {
  const b = e.target.closest('[data-flame]'); if (!b) return; flameColor = b.dataset.flame; renderExtras();
  if (Extras.flame) { const o = makeFlame(flameColor); Extras.flame.setObject(o, 2.4); Extras.flameObj = o; }
});
$('#oilSel').addEventListener('change', e => { oilIdx = +e.target.value; renderExtras(); if (Extras.oilObj) setOilLabel(Extras.oilObj, OILS[oilIdx].slug); });
const exView = { flame:0, oil:0 };
function exList(which) {
  return which === 'flame' ? ['3d', FLAME[flameColor].img, 'img/flame-life.webp', 'img/flame-box.webp'] : ['3d', 'img/oils/' + OILS[oilIdx].slug + '.webp'];
}
function renderExThumbs(which) {
  const list = exList(which); const box = $(`.ex__thumbs[data-for="${which}"]`); if (!box) return;
  if (threeFailed && exView[which] === 0) exView[which] = 1;
  box.innerHTML = list.map((s, i) => s === '3d' ? (threeFailed ? '' : `<button class="thumb thumb--3d" type="button" data-i="${i}" aria-pressed="${i === exView[which]}">3D</button>`)
    : `<button class="thumb" type="button" data-i="${i}" aria-pressed="${i === exView[which]}"><img src="${AW(s, 72)}" alt="" loading="lazy"></button>`).join('');
  const img = $('#' + which + 'Img'); const s = list[exView[which]] || list[0];
  if (s === '3d') img.hidden = true; else { img.src = AW(s, img.parentElement.clientWidth || 480); img.hidden = false; }
}
$$('.ex__thumbs').forEach(box => box.addEventListener('click', e => {
  const b = e.target.closest('[data-i]'); if (!b) return; exView[box.dataset.for] = +b.dataset.i; renderExThumbs(box.dataset.for);
}));
$('#addFlame').addEventListener('click', () => {
  const f = FLAME[flameColor];
  addToCart({ id:f.id, qty:1, kind:'flame', title:'flame', variant:{ color:flameColor }, price:f.price, img:f.img });
});
$('#addOil').addEventListener('click', () => {
  const o = OILS[oilIdx];
  addToCart({ id:o.id, qty:1, kind:'oil', title:'oil', variant:{ name:o.name }, price:o.price, img:'img/oils/' + o.slug + '.webp' });
});
async function initExtras() {
  if (!(await loadThree())) { renderExThumbs('flame'); renderExThumbs('oil'); return; }
  Extras.flame = new Viewer($('#flame3d'), { fit:0.82, width:2.2, yaw:-0.35, auto:0.0025, exposure:1.05 });
  Extras.flameObj = makeFlame(flameColor); Extras.flame.setObject(Extras.flameObj, 2.4);
  Extras.flame.onFrame = time => animateFlame(Extras.flameObj, time);
  Extras.oil = new Viewer($('#oil3d'), { fit:0.8, width:1.5, yaw:0.25, auto:0.0025 });
  Extras.oilObj = makeOil(OILS[oilIdx].slug); Extras.oil.setObject(Extras.oilObj, 2.15);
}

/* ---------------- Cart ---------------- */
let cart = store.get('hdd.cart', []);
if (!Array.isArray(cart)) cart = [];
{ // re-price saved carts so they always match the live catalogue
  const P = {}; for (const m of ['A', 'B']) for (const f in ROBOT[m]) P[ROBOT[m][f].id] = ROBOT[m][f].price;
  for (const c in FLAME) P[FLAME[c].id] = FLAME[c].price; OILS.forEach(o => P[o.id] = o.price);
  cart = cart.filter(l => l && P[l.id] != null && l.qty > 0); cart.forEach(l => l.price = P[l.id]);
}
function lineTitle(l) {
  if (l.kind === 'robot') return 'Robot Aroma';
  if (l.kind === 'flame') return t('x.flame');
  return t('x.oil');
}
function lineVariant(l) {
  if (l.kind === 'robot') return t(l.variant.model === 'B' ? 'p.modelB' : 'p.modelA') + ' · ' + l.variant.frag[0].toUpperCase() + l.variant.frag.slice(1);
  if (l.kind === 'flame') return t(l.variant.color === 'black' ? 'x.black' : 'x.white');
  const o = OILS.find(x => x.name === l.variant.name); return (o ? oilName(o) : l.variant.name) + ' · 10 ml';
}
function saveCart() { store.set('hdd.cart', cart); }
function addToCart(item) {
  const ex = cart.find(l => l.id === item.id);
  if (ex) ex.qty = Math.min(20, ex.qty + item.qty); else cart.push(item);
  saveCart(); renderCart(); toast(t('added')); bump();
}
function bump() { const n = $('#cartN'); n.animate([{ transform:'scale(1.4)' }, { transform:'scale(1)' }], { duration:300, easing:'ease-out' }); }
function renderCart() {
  const n = cart.reduce((a, l) => a + l.qty, 0);
  $('#cartN').textContent = n; $('#cartN').hidden = n === 0;
  $('#cartList').innerHTML = cart.map((l, i) => `<li class="line"><img src="${AW(l.img, 72)}" alt="">
    <div><div class="line__t">${esc(lineTitle(l))}</div><div class="line__v">${esc(lineVariant(l))}</div>
    <div class="line__ctl"><div class="qty"><button type="button" data-dec="${i}" aria-label="−">−</button><output>${l.qty}</output><button type="button" data-inc="${i}" aria-label="+">+</button></div>
    <button class="line__rm" type="button" data-rm="${i}">${esc(t('c.rm'))}</button></div></div>
    <div class="line__p">${money(l.price * l.qty)}</div></li>`).join('');
  $('#cartEmpty').hidden = cart.length > 0;
  $('#cartSub').textContent = money(cart.reduce((a, l) => a + l.price * l.qty, 0));
  const co = $('#checkout');
  if (cart.length) { co.href = `${SHOP_URL}/cart/` + cart.map(l => `${l.id}:${l.qty}`).join(','); co.setAttribute('aria-disabled', 'false'); }
  else { co.href = '#'; co.setAttribute('aria-disabled', 'true'); }
  $('#cartHero').hidden = !cart.some(l => l.kind === 'robot') || RobotStage.failed;
}
$('#cartList').addEventListener('click', e => {
  const b = e.target.closest('button'); if (!b) return;
  if (b.dataset.inc != null) cart[+b.dataset.inc].qty = Math.min(20, cart[+b.dataset.inc].qty + 1);
  if (b.dataset.dec != null) { const l = cart[+b.dataset.dec]; l.qty--; if (l.qty < 1) cart.splice(+b.dataset.dec, 1); }
  if (b.dataset.rm != null) cart.splice(+b.dataset.rm, 1);
  saveCart(); renderCart(); RobotStage.route();
});
function openCart(on) {
  $('#drawer').classList.toggle('is-on', on); $('#scrim').classList.toggle('is-on', on);
  $('#drawer').setAttribute('aria-hidden', String(!on));
  if (on) $('#cartClose').focus();
  RobotStage.route();
}
$('#cartOpen').addEventListener('click', () => openCart(true));
$('#cartClose').addEventListener('click', () => openCart(false));
$('#scrim').addEventListener('click', () => openCart(false));
addEventListener('keydown', e => { if (e.key === 'Escape') openCart(false); });
let toastT;
function toast(msg) { const el = $('#toast'); $('span', el).textContent = msg; el.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(() => el.classList.remove('is-on'), 1800); }

/* ---------------- Reviews (real orders only, read from reviews.json) ---------------- */
let REVIEWS = [];
async function loadReviews() {
  try { const r = await fetch(A('reviews.json'), { cache:'no-store' }); if (r.ok) { const j = await r.json(); if (Array.isArray(j)) REVIEWS = j.filter(x => x && x.name && x.text && x.rating >= 1 && x.rating <= 5); } } catch (e) {}
  renderReviews();
}
const stars = n => { const k = Math.round(n); return '★★★★★'.slice(0, k) + '☆☆☆☆☆'.slice(0, 5 - k); };
function renderReviews() {
  const sec = $('#reviews'); if (!sec) return;
  sec.hidden = REVIEWS.length === 0; if (!REVIEWS.length) return;
  const avg = REVIEWS.reduce((a, r) => a + r.rating, 0) / REVIEWS.length;
  $('#revAvg').innerHTML = `<span class="stars" aria-hidden="true">${stars(avg)}</span><span>${avg.toLocaleString(LOCALE, { maximumFractionDigits:1 })} / 5 · ${REVIEWS.length}</span>`;
  $('#revList').innerHTML = REVIEWS.map(r => `<article class="rev"><div class="rev__top"><span class="stars" aria-label="${r.rating}/5">${stars(r.rating)}</span><span>${r.date ? esc(new Date(r.date).toLocaleDateString(LOCALE)) : ''}</span></div>${r.photo ? `<img src="${esc(r.photo)}" alt="" loading="lazy">` : ''}<p>${esc(r.text)}</p><div class="rev__who">${esc(r.name)}${r.country ? ' · ' + esc(r.country) : ''}</div>${r.verified === false ? '' : `<div class="rev__ok">✓ ${esc(t('r.v'))}</div>`}</article>`).join('');
}

/* ---------------- Modes timelines ---------------- */
function drawModes() {
  $$('.tl canvas').forEach(cv => {
    const every = +cv.dataset.every; const w = cv.clientWidth, h = 46; if (!w) return;
    const dpr = DPR(); cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
    const g = cv.getContext('2d'); g.scale(dpr, dpr); g.clearRect(0, 0, w, h);
    g.strokeStyle = 'rgba(255,255,255,.22)'; g.lineWidth = 1; g.beginPath(); g.moveTo(0, h - 8); g.lineTo(w, h - 8); g.stroke();
    g.strokeStyle = '#cfae63'; g.lineWidth = every <= 2 ? 1 : 2.5;
    for (let s = 0; s <= 180; s += every) { const x = Math.min(w - 1.5, Math.max(1.5, s / 180 * w)); g.beginPath(); g.moveTo(x, h - 8); g.lineTo(x, every <= 2 ? h - 22 : 6); g.stroke(); if (every > 2) { g.fillStyle = '#cfae63'; g.beginPath(); g.arc(x, 6, 3.5, 0, 7); g.fill(); } }
  });
}

/* ---------------- Legal documents ---------------- */
function docHTML(key) {
  const b = CFG.business; const L = (LANG === 'es') ? 'es' : 'en';
  const D = DOCS[L][key]; let html = D.body
    .replace(/\{name\}/g, fill(b.name)).replace(/\{nif\}/g, fill(b.nif)).replace(/\{address\}/g, fill(b.address)).replace(/\{email\}/g, fill(b.email))
    .replace(/\{days\}/g, fill(CFG.shipDays)).replace(/\{shipcost\}/g, esc(shipText(L))).replace(/\{shop\}/g, ON_SHOP ? location.hostname : CFG.shop);
  if (LANG !== 'es' && LANG !== 'en') html = `<p class="muted">${esc(t('doc.only'))}</p>` + html;
  return { h: D.h, html };
}
$$('[data-doc]').forEach(b => b.addEventListener('click', () => {
  const d = docHTML(b.dataset.doc); const L = LANG === 'es' ? 'es' : 'en';
  $('#docH').textContent = d.h; $('#docB').innerHTML = d.html;
  $('#doc').setAttribute('lang', L); $('#doc').setAttribute('dir', 'ltr'); $('#doc').showModal();
}));
$('#docClose').addEventListener('click', () => $('#doc').close());
$('#doc').addEventListener('click', e => { if (e.target === $('#doc')) $('#doc').close(); });

/* ---------------- Boot ---------------- */
(function boot() {
  const sel = $('#lang'); sel.innerHTML = LANGS.map(([c, n]) => `<option value="${c}">${n}</option>`).join('');
  sel.addEventListener('change', () => setLang(sel.value));
  if (!CFG.preview) document.documentElement.classList.add('no-preview');
  else if (!sessionStorageGet('hdd.pbar')) { $('#pbar').hidden = false; document.documentElement.classList.add('has-pbar'); }
  if (ON_SHOP) ['#buyNow', '#checkout'].forEach(q => { const el = $(q); if (el) { el.removeAttribute('target'); el.removeAttribute('rel'); } });
  $('#pbarX').addEventListener('click', () => { $('#pbar').hidden = true; document.documentElement.classList.remove('has-pbar'); sessionStorageSet('hdd.pbar', 1); });
  if (!store.get('hdd.ck', false)) $('#cookie').hidden = false;
  $('#cookieOk').addEventListener('click', () => { store.set('hdd.ck', true); $('#cookie').hidden = true; });
  setLang(pickLang());
  sizeFilm(); tick(true); loadFilm();
  const go = () => { RobotStage.init(); initExtras(); };
  loadReviews();
  if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout:1200 }); else setTimeout(go, 300);
})();
function sessionStorageGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
function sessionStorageSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

/* --- Glass base: the scanned base is replaced by a modelled one (clear glass, amber and blue iridescence) --- */
function gradTex() {
  const c = document.createElement('canvas'); c.width = 512; c.height = 64; const g = c.getContext('2d');
  const gr = g.createLinearGradient(0, 0, 512, 0);
  [[0, 'rgba(10,60,220,.55)'], [0.1, 'rgba(30,110,255,.95)'], [0.2, 'rgba(110,210,255,.7)'], [0.28, 'rgba(0,0,0,.15)'],
   [0.4, 'rgba(255,170,40,.95)'], [0.52, 'rgba(230,150,30,1)'], [0.6, 'rgba(255,215,120,.7)'], [0.7, 'rgba(0,0,0,.15)'], [0.82, 'rgba(40,120,255,.9)'], [1, 'rgba(10,60,220,.55)']]
    .forEach(([o, col]) => gr.addColorStop(o, col));
  g.fillStyle = gr; g.fillRect(0, 0, 512, 64);
  // vertical streaks, like the reflections in the supplier photos
  for (let i = 0; i < 26; i++) { const x = Math.random() * 512, w = 1 + Math.random() * 5; g.fillStyle = `rgba(255,255,255,${0.05 + Math.random() * 0.18})`; g.fillRect(x, 0, w, 64); }
  const vg = g.createLinearGradient(0, 0, 0, 64); vg.addColorStop(0, 'rgba(0,0,0,.55)'); vg.addColorStop(0.25, 'rgba(0,0,0,0)'); vg.addColorStop(0.7, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(0,0,0,.6)');
  g.globalCompositeOperation = 'source-atop'; g.fillStyle = vg; g.fillRect(0, 0, 512, 64); g.globalCompositeOperation = 'source-over';
  const t = new THREE.CanvasTexture(c); t.offset.x = 0.62; t.colorSpace = THREE.SRGBColorSpace; t.wrapS = THREE.RepeatWrapping; return t;
}
function makeGlassBase(r, h) {
  const g = new THREE.Group();
  const glass = new THREE.MeshPhysicalMaterial({ color:'#ffffff', metalness:0, roughness:0.04, transparent:true, opacity:0.16, iridescence:1, iridescenceIOR:1.5,
    iridescenceThicknessRange:[260, 820], clearcoat:1, clearcoatRoughness:0.03, envMapIntensity:2.6, side:THREE.DoubleSide, depthWrite:false });
  const shell = new THREE.Mesh(new THREE.CylinderGeometry(r, r, h * 0.9, 128, 1, true), glass); shell.position.y = h * 0.55; shell.renderOrder = 3; g.add(shell);
  const back = new THREE.Mesh(new THREE.CylinderGeometry(r * 0.93, r * 0.93, h * 0.84, 96, 1, true), new THREE.MeshStandardMaterial({ color:'#030406', roughness:0.4, metalness:0.2, transparent:true, opacity:0.78, side:THREE.BackSide, depthWrite:false }));
  back.position.y = h * 0.55; back.renderOrder = 1; g.add(back);
  const band = new THREE.Mesh(new THREE.CylinderGeometry(r * 0.965, r * 0.965, h * 0.82, 128, 1, true),
    new THREE.MeshStandardMaterial({ map:gradTex(), transparent:true, metalness:0.35, roughness:0.1, envMapIntensity:1.6, emissive:'#ffffff', emissiveIntensity:0.0, side:THREE.FrontSide, depthWrite:false }));
  band.position.y = h * 0.55; band.renderOrder = 2; g.add(band);
  const top = new THREE.Mesh(new THREE.RingGeometry(r * 0.42, r, 128), new THREE.MeshPhysicalMaterial({ color:'#1a1d22', metalness:0.2, roughness:0.08, clearcoat:1, transparent:true, opacity:0.72, envMapIntensity:2 }));
  top.rotation.x = -Math.PI / 2; top.position.y = h * 1.0; g.add(top);
  const seat = new THREE.Mesh(new THREE.CylinderGeometry(r * 0.44, r * 0.48, h * 0.08, 64), new THREE.MeshStandardMaterial({ color:'#08090b', metalness:0.6, roughness:0.25 }));
  seat.position.y = h * 0.98; g.add(seat);
  const core = new THREE.Mesh(new THREE.CylinderGeometry(r * 0.2, r * 0.26, h * 0.78, 48), new THREE.MeshPhysicalMaterial({ color:'#11151b', metalness:0.3, roughness:0.15, clearcoat:1, envMapIntensity:1.6 }));
  core.position.y = h * 0.52; g.add(core);
  const lip = new THREE.Mesh(new THREE.TorusGeometry(r * 0.995, h * 0.022, 12, 128), new THREE.MeshStandardMaterial({ color:'#c9ccd2', metalness:1, roughness:0.18 }));
  lip.rotation.x = Math.PI / 2; lip.position.y = h * 1.0; g.add(lip);
  const foot = new THREE.Mesh(new THREE.CylinderGeometry(r * 1.05, r * 1.06, h * 0.1, 128), new THREE.MeshStandardMaterial({ color:'#0b0c0e', metalness:0.5, roughness:0.3 }));
  foot.position.y = h * 0.05; g.add(foot);
  const footLip = new THREE.Mesh(new THREE.TorusGeometry(r * 1.05, h * 0.012, 8, 128), new THREE.MeshStandardMaterial({ color:'#3a3d44', metalness:1, roughness:0.3 }));
  footLip.rotation.x = Math.PI / 2; footLip.position.y = h * 0.1; g.add(footLip);
  return g;
}
// Removes every triangle that lies entirely below `cut` (in the normalised space of `root`) and returns the removed area's centre.
function cutBelow(root, cut) {
  root.updateMatrixWorld(true);
  const inv = new THREE.Matrix4().copy(root.matrixWorld).invert(); const v = new THREE.Vector3(); let sx = 0, sz = 0, n = 0;
  root.traverse(o => {
    if (!o.isMesh) return;
    const geo = o.geometry, pos = geo.attributes.position; const M = new THREE.Matrix4().multiplyMatrices(inv, o.matrixWorld);
    const ys = new Float32Array(pos.count), xs = new Float32Array(pos.count), zs = new Float32Array(pos.count);
    for (let i = 0; i < pos.count; i++) { v.fromBufferAttribute(pos, i).applyMatrix4(M); xs[i] = v.x; ys[i] = v.y; zs[i] = v.z; }
    const idx = geo.index ? geo.index.array : [...Array(pos.count).keys()]; const keep = [];
    for (let t = 0; t < idx.length; t += 3) {
      const a = idx[t], b = idx[t + 1], c = idx[t + 2];
      if (ys[a] < cut && ys[b] < cut && ys[c] < cut) { sx += xs[a]; sz += zs[a]; n++; } else keep.push(a, b, c);
    }
    geo.setIndex(keep);
  });
  return { x: n ? sx / n : 0, z: n ? sz / n : 0 };
}
